import Ajax from '../common/ajax'
import Tool from '../common/tool'

export default {
  model: 'common',
  getAppInfo () {
    return Ajax.get(`/api/gradeEvaluation/v1/${this.model}/getHomeConfig`)
  },
  getTaskInfo (taskName) {
    return Ajax.get(`/api/gradeEvaluation/v1/${this.model}/taskInfo/${taskName}`)
  }
}
